import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { UATConstants } from '../../../Common/Models/UATConstants';
import {
  MANAGE_ACTION_API_CONSTANTS,
  MANAGE_ACTION_CONSTANTS,
} from '../../utils/manageActionConstants';

export interface IValidationRequestPayload {
  id: string;
  raidId: number;
  partitionKey: string | null;
  upn: string;
  isValidationRequired: boolean;
}

export interface IFieldValidation {
  fieldname: string;
  criteriaid?: string; //Optional for update scenarios
  fieldvalue: string;
  isvalid: boolean;
  message: string;
  comments: string;
  ismanual: boolean;
}

export interface IUpdateValidationResponse {
  raidid: number;
  offername: string;
  validatedby: string;
  validatedon: string;
  fields: IFieldValidation[];
  id: string;
}
export interface IValidationResponse extends IUpdateValidationResponse {
  _rid: string;
  _self: string;
  _etag: string;
  _attachments: string;
  _ts: number;
}

export const validationAutomationApi = createApi({
  reducerPath: 'validationAutomationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: UATConstants.CommonServicesWebApiUrl,
    prepareHeaders: (headers) => {
      const token = sessionStorage.getItem(MANAGE_ACTION_CONSTANTS.JWT_TOKEN_FOR_API);
      const coreAPIToken = sessionStorage.getItem(MANAGE_ACTION_CONSTANTS.JWT_TOKEN_FOR_CORE_API);
      const graphToken = sessionStorage.getItem(MANAGE_ACTION_CONSTANTS.JWT_TOKEN_FOR_GRAPH);

      if (token && graphToken && coreAPIToken) {
        headers.set('Authorization', `Bearer ${token}`);
        headers.set('Coreapitoken', coreAPIToken);
        headers.set('Graphtoken', graphToken);
      }
      return headers;
    },
  }),
  tagTypes: ['ValidationMessages'],
  endpoints: (builder) => ({
    // Get all validation messages
    getValidationMessages: builder.mutation<IValidationResponse, IValidationRequestPayload>({
      query: (request) => ({
        method: 'POST',
        url: MANAGE_ACTION_API_CONSTANTS.GetValidationAutomation,
        body: request,
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: 'ValidationMessages', id: arg.raidId }
      ],
    }),
    updateValidationMessage: builder.mutation<IUpdateValidationResponse, IUpdateValidationResponse>(
      {
        query: (request) => ({
          method: 'PATCH',
          url: MANAGE_ACTION_API_CONSTANTS.AddAndUpdateValidationMessage,
          body: request,
        }),
      }
    ),
  }),
});

// Export hooks for use in components
export const { useGetValidationMessagesMutation, useUpdateValidationMessageMutation } =
  validationAutomationApi;
